package com.eladfinish.bible.contest.screens.browse.tableOfContents.ui.menu

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.add_bookmark
import com.eladfinish.bible.contest.choose_aliyah
import com.eladfinish.bible.contest.font_size_change
import com.eladfinish.bible.contest.ic_bookmark
import com.eladfinish.bible.contest.ic_format_size
import com.eladfinish.bible.contest.ic_save_black
import com.eladfinish.bible.contest.save_content_in_file
import com.eladfinish.bible.contest.screens.browse.contentOfChapter.ui.BookmarkScrollController
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.BrowseMode
import com.eladfinish.bible.contest.shmot_onqelos
import com.eladfinish.bible.contest.tikun_korim
import com.eladfinish.bible.contest.ui.components.toolbar.SetToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionPlacement
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarHeaderComponentConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarIcon
import com.eladfinish.bible.contest.ui.components.toolbar.model.ToolbarKind
import com.eladfinish.bible.contest.ui.menus.actions.ChapterContentToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.ToolbarActionEmitter
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.desc.desc
import kotlinx.collections.immutable.toImmutableList

enum class ChapterContentToolbarId {
    ADD_BOOKMARK,
    CHANGE_FONT_SIZE,
    CHOOSE_ALIYAH,
    SHOW_ONQELOS,
    TIKUN_KORIM,
    SAVE_CONTENT,
}

@Composable
internal fun ChapterContentMenu(
    title: String,
    toolbarEmitter: ToolbarActionEmitter<ChapterContentToolbarAction>,
    isCompleteChapter: Boolean,
    browseMode: BrowseMode,
    bookmarkScrollController: BookmarkScrollController,
) {
    SetToolbarConfiguration(
        configuration = ToolbarConfiguration(
            kind = ToolbarKind.ChapterContent,
            title = ToolbarHeaderComponentConfig.Text(text = title),
            actions = listOfNotNull(
                ToolbarActionConfig.IconAction(
                    id = ChapterContentToolbarId.ADD_BOOKMARK,
                    icon = ToolbarIcon.PainterIcon(
                        painter = painterResource(imageResource = SharedRes.images.ic_bookmark)
                    ),
                    menuText = SharedRes.strings.add_bookmark.desc(),
                    onClick = {
                        toolbarEmitter.emit(
                            ChapterContentToolbarAction.AddBookmark(
                                scrollY = bookmarkScrollController.currentScrollY,
                                textOffset = bookmarkScrollController.currentTextOffset,
                            )
                        )
                    },
                    placement = ToolbarActionPlacement.OnToolbar,
                ).takeUnless { isCompleteChapter || browseMode == BrowseMode.SHONOT_MODE },
                ToolbarActionConfig.IconAction(
                    id = ChapterContentToolbarId.CHANGE_FONT_SIZE,
                    icon = ToolbarIcon.PainterIcon(
                        painter = painterResource(imageResource = SharedRes.images.ic_format_size)
                    ),
                    menuText = SharedRes.strings.font_size_change.desc(),
                    onClick = {
                        toolbarEmitter.emit(ChapterContentToolbarAction.ChangeFontSize)
                    },
                    placement = ToolbarActionPlacement.OnToolbar,
                ).takeUnless { isCompleteChapter },
                ToolbarActionConfig.TextActionRes(
                    id = ChapterContentToolbarId.CHOOSE_ALIYAH,
                    stringDesc = SharedRes.strings.choose_aliyah.desc(),
                    onClick = { toolbarEmitter.emit(ChapterContentToolbarAction.ChooseAliyah) },
                    placement = ToolbarActionPlacement.OnToolbar,
                ).takeIf { browseMode == BrowseMode.CHUMASH_MODE },
                ToolbarActionConfig.TextActionRes(
                    id = ChapterContentToolbarId.SHOW_ONQELOS,
                    stringDesc = SharedRes.strings.shmot_onqelos.desc(),
                    onClick = { toolbarEmitter.emit(ChapterContentToolbarAction.ShowOnqelos) },
                    placement = ToolbarActionPlacement.InOverflow,
                ).takeIf { browseMode == BrowseMode.CHUMASH_MODE },
                ToolbarActionConfig.TextActionRes(
                    id = ChapterContentToolbarId.TIKUN_KORIM,
                    stringDesc = SharedRes.strings.tikun_korim.desc(),
                    onClick = { toolbarEmitter.emit(ChapterContentToolbarAction.TikunKorim) },
                    placement = ToolbarActionPlacement.InOverflow,
                ).takeIf { browseMode == BrowseMode.CHUMASH_MODE },
                ToolbarActionConfig.IconAction(
                    id = ChapterContentToolbarId.SAVE_CONTENT,
                    icon = ToolbarIcon.PainterIcon(
                        painter = painterResource(imageResource = SharedRes.images.ic_save_black)
                    ),
                    menuText = SharedRes.strings.save_content_in_file.desc(),
                    onClick = { toolbarEmitter.emit(ChapterContentToolbarAction.SaveContent) },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
            ).toImmutableList(),
        ),
    )
}
